import { addStyles } from 'ethcss'
import { color, grid, IStyles, item, mediaCSS } from '../../theme'

const draftDevicesStyles: IStyles = {
    breadcrumbs: {
        ...grid.mb_md,
        ...grid.pl_mdPlus,
        ...item.white,
        marginLeft: -grid.m_mdPlus['margin'],
        marginTop: -grid.m_mdPlus['margin'],
        width: `calc(100% + ${2 * grid.m_mdPlus['margin']}px)`,
        [mediaCSS.tabMini]: {
            marginTop: -grid.m_mini['margin'],
            marginLeft: -grid.m_mini['margin'],
        },
    },
    width: {
        width: '55%',
        minWidth: 520,
        maxWidth: 640,
        [mediaCSS.tabMini]: {
            width: '90%',
            minWidth: 'unset',
            maxWidth: '100%',
        },
        [mediaCSS.mini]: {
            width: '100%',
        },
    },
    modalContent: {
        width: '100%',
        alignSelf: 'stretch',
    },
    dropdownField: {
        width: '100%',
    },
    noLicensesLeft: {
        display: 'flex',
        color: color.critical,

        span: {
            marginLeft: 10,
            fontSize: 11,
        },
    },
    licenseOption: {
        padding: 6,
        borderRadius: 5,
        backgroundColor: 'transparent',
        width: '100%',
        transition: 'background-color 0.3s',

        '&:hover': {
            backgroundColor: color.bgWhiteQuaternary,
        },
    },
    licenseOptionRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
    },
    licenseOptionName: {
        fontWeight: 'bold',
        flex: 1,
        minWidth: 0,
        textAlign: 'left',
    },
    licenseOptionDesc: {
        borderRadius: 5,
        backgroundColor: color.bgWhiteTertiary,
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
        flexShrink: 0,

        span: {
            color: color.blue,

            span: {
                color: color.blue500,
            },
        },
    },
    licenseHeaderDesc: {
        borderRadius: 5,
        backgroundColor: 'transparent',
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
        flexShrink: 0,

        span: {
            color: color.blue,

            span: {
                color: color.blue500,
            },
        },
    },
}

addStyles(draftDevicesStyles)
export default draftDevicesStyles
